import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../firebase';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';

const AdminRoute = () => {
  const [user, setUser] = useState(undefined);

  useEffect(() => onAuthStateChanged(auth, setUser), []);

  if (user === undefined) return <div className="admin-loading">Cargando...</div>;
  if (!user) return <AdminLogin />;
  return <AdminPanel />;
};

export default AdminRoute;
